<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">
        Options
        <span class="caret"></span>
      </button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} &amp; exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label for="ext-name" class="form-label">Name *</label>
              <input type="text" class="form-control" id="role-name" v-model="entity.name"/>
            </div>
            <div class="form-group">
              <label for="is-p" class="form-label">Is Parent?</label>
              <div class="material-switch">
                <input id="is-p" type="checkbox" v-model="entity.isParent"/>
                <label for="is-p" class="label-success"></label>
              </div>
            </div>
            <div class="form-group">
              <label for="pg" class="form-label">Parent group</label>
              <select class="form-control" id="pg" v-model="entity.parentGroup">
                <option value=""></option>
                <option v-for="(opt, i) in groups" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="tnt-code" class="form-label">Tenant</label>
              <input type="text" class="form-control" id="tnt-code" v-model="entity.tenant"/>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div v-if="entity.id">
              <div class="form-group">
                <label class="form-label">Add Parties</label>
                <autocomplete
                  :dataset="partySearchResults"
                  title="Party"
                  placeHolder="Type to search"
                  :initVal="party"
                  v-on:changing="data => partySearchText = data"
                  :fnFormatText="displayParty"
                  :fnSelectValue="displayParty"
                  v-on:selection-made="selectParty"
                ></autocomplete>
              </div>
              <vue-table
                v-on:table-delete-request="removeParty"
                :show-delete="true"
                :allow-select="false"
                :show-select-all="false"
                :table-data="partyToPartyGroups.filter(zone => zone.deleted !== 1)"
                table-title="Parties"
                :fields="fields"
                :max-items="maxValue"
                v-on:pages-remaining="loadMore"
              ></vue-table>
            </div>
            <div v-else class="mt-20 mb-15">
              <p>Once you have saved the PartyGroup, you will be able to add parties</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  import VueTable from '../../../helpers/VueTable.vue'
  import API from '../../../../api/endpoints'
  import event from '../../../../event'
  export default {
    name: 'PartyGroup',
    components: { Autocomplete, VueTable },
    mixins: [AdminEntityMixin, HelperMixin],
    data () {
      return {
        partyToPartyGroups: [],
        partySearchResults: [],
        partySearchText: null,
        party: null,
        shouldUpdateCache: true,
        cachePropertyName: 'partyGroups',
        transformForUpdate: {
          parentGroup: this.toMinus
        },
        newEntityScreen: 'Admin - Party Groups',
        editEntityScreen: 'Admin - Edit/View Party Group',
        tab: 'main',
        entity: {
          id: null,
          name: null,
          tenant: null,
          parentGroup: null,
          isParent: null
        },
        entityName: 'party-group',
        boxes: [
          {
            prop: 'parentGroup',
            id: 'id'
          }
        ],
        fields: [
          { header: 'name', prop: item => item.party && this.getPartyText(item.party) }
        ],
        maxValue: 0,
        page: 1,
        fetching: true
      }
    },
    computed: {
      isValid () {
        return this.entity.name && this.entity.name.trim().length
      },
      groups () {
        return this.$store.getters['systemOption/partyGroups'].filter(({isParent}) => isParent)
      },
      fullyLoaded () {
        return this.vendorLocations.length === this.maxValue
      }
    },
    methods: {
      getPartyText (p) {
        if (!p) { return '' }
        const data = []
        data.push(p.name)
        if (p.code) {
          data.push(p.code)
        }
        if (p.address) {
          const address = p.address
          if (address.subdivision) {
            data.push(address.subdivision)
          }
          if (address.country && address.country.code) {
            data.push(address.country.code)
          }
        }
        return data.join(', ')
      },
      removeParty ({ item }) {
        const i = this.partyToPartyGroups.findIndex(({party}) => party && party.id && item && item.party && item.party.id === party.id)
        if (item.id) {
          this.deleteRelatedEntity('party-to-party-group', item.id)
            .then(({data}) => {
              event.$emit('toast', { type: 'success', message: 'Party deleted' })
              this.partyToPartyGroups.splice(i, 1)
            })
            .catch(err => {
              event.$emit('toast', { type: 'error', message: 'Unable to delete Party; please try again or contact support' })
              console.log(err)
            })
        }
      },
      selectParty (party) {
        if (Object.keys(party).length > 0) {
          this.saveRelatedEntity('party-to-party-group', {
            id: null,
            partyGroup: this.entity.id,
            party,
            deleted: 0
          }).then(({data}) => {
            event.$emit('toast', { type: 'success', message: 'Party added' })
            this.partyToPartyGroups.push(data)
          })
            .catch(err => {
              event.$emit('toast', { type: 'error', message: 'Unable to add party; please try again or contact support' })
              console.log(err)
            })
        }
        this.partySearchText = ''
        this.partySearchResults = []
        this.$nextTick(() => {
          this.party = ''
        })
      },
      displayParty (p) {
        return `${p.name}, ${p.code}`
      },
      getBaseData () {
        return {
          id: null,
          name: null,
          tenant: null,
          parentGroup: null,
          isParent: null
        }
      },
      loadMore (page = null) {
        if (!this.fetching && !this.fullyLoaded) {
          this.fetching = true
          const pageToLoad = page || ++this.page
          this.$http.get((API.GET_ENTITIES('party-to-party-group'), {
            params: { partyGroup: this.entity.id },
            headers: {
              'X-Limit': '500',
              'X-Page-Number': String(pageToLoad),
              'X-Lazy-Fetch': '1'
            }
          }))
            .then(({data}) => {
              this.partyToPartyGroups = data
            }).catch(err => console.log(err))
            .then(() => {
              this.fetching = false
            })
        }
      },
      refresh () {
        if (this.entity.id) {
          this.fetching = true
          this.$http.get(API.GET_ENTITIES('party-to-party-group'), {
            params: { partyGroup: this.entity.id },
            headers: {
              'X-Limit': '500',
              'X-Page-Number': '1',
              'X-Lazy-Fetch': '1'
            }
          })
            .then(({data}) => {
              this.partyToPartyGroups = data
            }).catch(err => console.log(err))
            .then(() => {
              this.fetching = false
            })
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// PartyGroup.vue?b163a9e0